// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3vDd1","question":"Question_question__30L_A","description":"Question_description__3zKhq"};